// Maps apparel color names (from Chipply) to display hex values for swatches.
const COLOR_MAP = {
  "black": "#1a1a1a",
  "white": "#f5f5f0",
  "natural": "#efe6d2",
  "sand": "#d8c9a3",
  "brown savana": "#8b6f47",
  "dark chocolate": "#3b2417",
  "sport grey": "#b0b0b0",
  "carolina blue": "#7ba7d7",
  "sky": "#87ceeb",
  "stone blue": "#6e7f8d",
  "navy": "#1f2a44",
  "royal": "#1e3fae",
  "true royal": "#1d4ed8",
  "forest green": "#22462f",
  "military green": "#4b5320",
  "teal": "#0f7d7d",
  "maroon": "#6a1b2a",
  "red": "#c0392b",
  "light pink": "#f4c2c2",
  "heather mauve": "#9b6a6c",
  "purple": "#5b2a83",
  "team purple": "#4b2e83",
  "tangerine": "#f28500",
  "texas orange": "#bf5700",
};

export function colorHex(name) {
  if (!name) return "#8f857a";
  return COLOR_MAP[name.trim().toLowerCase()] || "#8f857a";
}
